module.exports = __webpack_public_path__ + "static/media/country_ua.caf54f2a.webp";